// Class names and element ids for the React MDS chart.
// All prefixed with `mds-` so the chart is self-contained: when the legacy D3 chart is
// rendered alongside for comparison, its unscoped selectors (`.points .point`,
// `d3.selectAll('.points …')`) and duplicate ids (`line_…`, `gradient-…`) cannot reach
// or shadow these. Single source of truth — every selector/creation references here.

export const CLS = {
  selected: 'mds-selected',
  axises: 'mds-axises',
  lines: 'mds-lines',
  points: 'mds-points',
  point: 'mds-point',
  bublik: 'mds-bublik',
  axisLines: 'mds-axis-lines',
  axis: 'mds-axis',
  centerOuter: 'mds-center-outer',
  centerInner: 'mds-center-inner',
  endOuter: 'mds-end-outer',
  endInner: 'mds-end-inner',
  outer: 'mds-outer',
  inner: 'mds-inner',
  label: 'mds-label', // legacy class is `mds-labeltext` — renamed to avoid self-collision
  axisLabel: 'mds-axis-label', // legacy class is `axises-labeltext`
  pointPath: 'mds-point-path'
}

export const ID = {
  line: (x, y) => `mds-line_${x}${y}`,
  gradient: (questionId, pointId, x, y) => `mds-gradient-${questionId}-${pointId}${x}${y}`,
  arrowDark: id => `mds-arrow-dark-${id}`, // legacy `arrow-mds-{id}`
  arrowGray: id => `mds-arrow-gray-${id}`,
  bg: id => `mds-bg-${id}`
}
